// src/components/reports/quoteState.js
//
// How a roadmap item's quote-state is worded and coloured. ONE definition,
// because it renders on THREE surfaces — the Monthly Reports roadmap modal, the
// Meeting Notes section, and the client-facing meeting page — and a badge that
// says "Quoted" in one place and "Sent" in another is worse than no badge.
//
// ⛔ QUOTE-STATE IS A SEPARATE AXIS FROM THE ROADMAP STATUS. A row reads
// "Budgeted · Quoted": the first says what kind of work it is, the second says
// how far the paperwork has got. Never collapse them into one label.
//
// React-free so it can be unit-tested and reused from the plain-HTML meeting
// page bundle without dragging a component in.

export const QUOTE_STATES = ["not_quoted", "quoted", "quote_accepted"];

/* ⚠ `quote_accepted` RENDERS TODAY even though nothing sets it yet — the accept
   transition belongs to the quoting workstream. The join key is the item's
   `linkedQuoteId`; a later change there finds the item and flips the state. If
   this map lacked the case, that change would ship a blank badge. */
const VIEW = {
  not_quoted:     { label: "Not quoted",     bg: "#f1f1f1", fg: "#555"    },
  quoted:         { label: "Quoted",         bg: "#eef4fb", fg: "#2a5f9e" },
  quote_accepted: { label: "Quote Accepted", bg: "#e9f6ee", fg: "#00631f" },
};

/** Never returns undefined — an unknown state degrades to "not quoted". */
export function quoteStateView(state) {
  return VIEW[state] || VIEW.not_quoted;
}

/** Has a quote been raised? Both quoted and accepted count. */
export function isQuoted(state) {
  return state === "quoted" || state === "quote_accepted";
}

/** "Quoted · 3 Sep 2026" — the date only when we actually have one. */
export function quotedLabel(item) {
  const view = quoteStateView(item?.quoteState);
  if (!isQuoted(item?.quoteState)) return view.label;
  const at = item?.quotedAt ? new Date(item.quotedAt) : null;
  /* ⚠ Guard the date. A stored value that will not parse yields "Invalid Date"
     from toLocaleDateString — it does not throw — and that string would land on
     a page a client is looking at. Same trap as the opportunity email times. */
  if (!at || Number.isNaN(at.getTime())) return view.label;
  return `${view.label} · ${at.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" })}`;
}
